module.exports = __webpack_public_path__ + "assets/img/en.0984e617.png";